import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const EMPTY_FORM = {
  first_name: "",
  last_name: "",
  username: "",
  email: "",
  contact_no: "",
  address: "",
  password: "",
  confirmPassword: "",
};

const UsersSection = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [currentAdmin, setCurrentAdmin] = useState(null);


const [editUserId, setEditUserId] = useState(null);

  useEffect(() => {
  fetchUsers();
  fetchCurrentAdmin();
}, []);


const fetchUsers = async () => {
  try{
 const res = await api.get("companyblog/admin/users/");
    setUsers(res.data);
  } catch (err) {
    console.error("Failed to fetch users", err);
  }
};

const fetchCurrentAdmin = async () => {
  try {
    const res = await api.get("companyblog/admin/me/");
    setCurrentAdmin(res.data); // contains username
  } catch (err) {
    console.error("Failed to fetch admin info", err);
  }
};


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async () => {
  if (!isEditMode && form.password !== form.confirmPassword) {
    alert("Passwords do not match");
    return;
  }

  const payload = { ...form };

  // Do NOT send empty passwords on edit
  if (isEditMode && !form.password) {
    delete payload.password;
    delete payload.confirmPassword;
  }

  try {
    if (isEditMode) {
      await api.put(
        `companyblog/admin/users/${editUserId}/`,
        payload
      );
    } else {
      await api.post(
        "companyblog/admin/users/",
        payload
      );
    }

    setShowModal(false);
    setIsEditMode(false);
    setEditUserId(null);
    setForm(EMPTY_FORM);
    fetchUsers();

  } catch (err) {
    console.error("Failed to save user", err);
    alert("Failed to save user");
  }
};

const deleteUser = async (id) => {
  if (!window.confirm("Delete this user?")) return;

  try {
    await api.delete(
      `companyblog/admin/users/${id}/delete/`
    );
    fetchUsers();
  } catch (err) {
    console.error("Failed to delete user", err);
    alert("Failed to delete user");
  }
};


  return (
    <div>
      <div style={styles.header}>
        <h2>Users</h2>
        <button style={styles.addBtn} onClick={() => {setIsEditMode(false); setEditUserId(null); setForm(EMPTY_FORM);
            setShowModal(true);
            }}>
          + Add User
        </button>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th>Username</th>
            <th>Email</th>
            <th>Name</th>
            <th>Roles</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>{u.email}</td>
              <td>{u.first_name} {u.last_name}</td>
              <td><b>{u.is_superuser? "ADMIN": u.is_staff? "Admin": "USER"}</b></td>
              <td><button
                    style={styles.editBtn}
                    onClick={() => {
                      setIsEditMode(true);
                      setEditUserId(u.id);
                      setForm({
                        first_name: u.first_name || "",
                        last_name: u.last_name || "",
                        username: u.username || "",
                        email: u.email || "",
                        contact_no: u.contact_no || "",
                        address: u.address || "",
                        password: "",
                        confirmPassword: "",
                      });
                      setShowModal(true);
                    }}
                  >
                    Edit
                  </button></td>
              <td>
                <button style={{...styles.deleteBtn,background:currentAdmin?.username === u.username ? "#9ca3af" : "#e74c3c",cursor:currentAdmin?.username === u.username ? "not-allowed" : "pointer",opacity: currentAdmin?.username === u.username ? 0.6 : 1,}}disabled={currentAdmin?.username === u.username}onClick={() => deleteUser(u.id)}title={currentAdmin?.username === u.username? "You cannot delete your own admin account": "Delete user"}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

{showModal && (
  <div style={styles.modalOverlay}>
    <div style={styles.modalLarge}>
      <h3 style={{ marginBottom: "20px" }}>
        {isEditMode ? "Edit User" : "Add User"}
      </h3>

      {/* Row 1: First + Last name */}
      <div style={styles.row}>
        <div style={styles.field}>
          <label>First Name</label>
          <input
            name="first_name"
            placeholder="First Name"
            value={form.first_name}
            onChange={handleChange}
          />
        </div>

        <div style={styles.field}>
          <label>Last Name</label>
          <input
            name="last_name"
            placeholder="Last Name"
            value={form.last_name}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Username */}
      <div style={styles.field}>
        <label>Username</label>
        <input
          name="username"
          placeholder="Username"
          value={form.username}
          disabled={isEditMode}
          onChange={handleChange}
        />
      </div>

      {/* Contact */}
      <div style={styles.field}>
        <label>Contact</label>
        <input
          name="contact_no"
          placeholder="Mobile / Phone"
          value={form.contact_no}
          onChange={handleChange}
        />
      </div>

      {/* Email */}
      <div style={styles.field}>
        <label>Email</label>
        <input
          name="email"
          placeholder="Email"
          value={form.email}
          disabled={isEditMode}
          onChange={handleChange}
        />
      </div>

      {/* Address */}
      <div style={styles.field}>
        <label>Address</label>
        <input
          name="address"
          placeholder="Address"
          value={form.address}
          onChange={handleChange}
        />
      </div>

      {/* Password */}
      <div style={styles.field}>
        <label>Password</label>
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
        />
      </div>

      {/* Confirm Password (Add only) */}
      {!isEditMode && (
        <div style={styles.field}>
          <label>Re-type Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleChange}
          />
        </div>
      )}

      {/* Footer */}
      <div style={styles.footer}>
        <button style={styles.primaryBtn} onClick={handleSubmit}>
          {isEditMode ? "Update" : "Create"}
        </button>

        <button
          style={styles.cancelBtn}
          onClick={() => {
            setShowModal(false);
            setIsEditMode(false);
            setEditUserId(null);
            setForm(EMPTY_FORM);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};
const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },
  addBtn: {
    background: "#4a63e7",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
  },
  table: {
    width: "100%",
    background: "#fff",
    borderCollapse: "collapse",
  },
  deleteBtn: {
    background: "#e74c3c",
    color: "#fff",
    border: "none",
    padding: "5px 10px",
  },
  modalLarge: {
  background: "#fff",
  padding: "25px",
  width: "650px",
  borderRadius: "10px",
},

row: {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "15px",
},

field: {
  display: "flex",
  flexDirection: "column",
  marginBottom: "15px",
},

footer: {
  display: "flex",
  gap: "10px",
  marginTop: "20px",
},

primaryBtn: {
  background: "#1aa6b7",
  color: "#fff",
  border: "none",
  padding: "10px 20px",
  borderRadius: "6px",
},

cancelBtn: {
  background: "#eee",
  border: "none",
  padding: "10px 20px",
  borderRadius: "6px",
},

};

export default UsersSection;
